import { useEffect, useState } from "react"
import { TranslationsStringsType } from "../../models/enum/rsvpEnum"
import { RsvpDetails, Settings, StepsTranslations } from "../../models/api/rsvpApiTypes"
import { useAppSelector } from "../../hook/useReduxHooks"
import { RootState } from "../../redux/store"
import { resolveTranslation } from "../../utils/translations"
import RsvpBox from "../RsvpBox"
import dateStepIcon from "../../icon/date-icon.svg"
import StepDate from "./StepDate"

interface StepArrivalDateBoxProps {
  settings: Settings
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  stepPipeline: string[]
  setStep: (name: string) => void
}

export default function StepArrivalDateBox({ settings, rsvp, stepPipeline, setRsvp, setStep }: StepArrivalDateBoxProps) {
  const [arrivalDateStrings, setArrivalDateStrings] = useState<StepsTranslations | undefined>({
    lang: "",
    strings: [],
  })
  const language = useAppSelector((state: RootState) => state.languageReducer.language).toLocaleLowerCase()

  useEffect(() => {
    const newArrivalDateStrings =
      resolveTranslation(settings.steps?.find((x) => x.name === "arrivalDate")?.translations ?? [], language)
    setArrivalDateStrings(newArrivalDateStrings)
  }, [language, settings.steps])

  return (
    <div className="box">
      <RsvpBox
        iconAlt="dateStepIcon"
        iconSource={dateStepIcon}
        title={arrivalDateStrings?.strings.find((x) => x.type === TranslationsStringsType.TITLE)?.value}
        description={arrivalDateStrings?.strings.find((x) => x.type === TranslationsStringsType.DESCRIPTION)?.value}
      >
        <StepDate
          buttonColor={settings.rsvpStyle.buttonColor === null ? "#0c6efb" : settings.rsvpStyle.buttonColor}
          backButtonColor={settings.rsvpStyle.backButtonColor === null ? "#a6b7d4" : settings.rsvpStyle.backButtonColor}
          strings={arrivalDateStrings?.strings}
          rsvp={rsvp}
          setRsvp={(rsvp) => setRsvp(rsvp)}
          setStep={(name) => setStep(name)}
          stepPipeline={stepPipeline}
        />
      </RsvpBox>
    </div>
  )
}
